<template>
    <div @click="toggleCarnet()" class="c-overlay__notebook__bg"></div>
    <div class="c-overlay__notebook__panel o-card -card-padding u-bg-color-1 u-color-white">
        <button @click="toggleCarnet()" class="c-overlay__notebook__close">
            <svg aria-hidden="true" focusable="false" class="o-ico c-overlay__notebook__close__icon">
                <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#search-close"></use>
            </svg>
        </button>
        <h3 class="o-title-3">
            Mon carnet
        </h3>
        <CarnetCart v-if="view=='cart'" :loggedIn="loggedIn" :posts="posts" @toggleView="toggleView" @deletePost="deletePost" @logout="logout" />
        <CarnetLogin v-if="view=='login'" @toggleView="toggleView" />
        <CarnetRegister v-if="view=='register'" @toggleView="toggleView" />
        <CarnetForgot v-if="view=='forgot'" @toggleView="toggleView" />
    </div>
</template>

<script>

import CarnetCart from './CarnetCart.vue';
import CarnetLogin from './CarnetLogin.vue';
import CarnetRegister from './CarnetRegister.vue';
import CarnetForgot from './CarnetForgot.vue';

export default {
    name: 'Carnet',
    components: {
        CarnetCart,
        CarnetLogin,
        CarnetRegister,
        CarnetForgot,
    },
    data() {
        return {
            view: 'cart',
            loggedIn: false,
            url: window.location.href,
            posts: []
        }
    },
    mounted() {
        this.emitter.on('addToCarnet', this.addPost);
        this.emitter.on('removeFromCarnet', this.deletePost);
        this.emitter.on('getCart', this.getPosts);
        this.emitter.on('callCarnetContent', () => this.emitter.emit('carnetContent', this.posts));
        this.getPosts();
    },
    unmounted() {
        this.emitter.off('addToCarnet', this.addPost);
        this.emitter.off('removeFromCarnet', this.deletePost);
        this.emitter.off('getCart', this.getPosts);
    },
    methods: {
        toggleCarnet() {
            document.querySelector('html').classList.toggle('has-notebook-open');
        }
        ,
        toggleView(view) {
            if (view == 'login' && this.loggedIn) view = 'cart';
            this.view = view;
        },
        getPosts: function() {
            fetch(WPURLS.ajax_url+'?action=get_favorites',
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'X-WP-Nonce': WPURLS.nonce
                    }
                })
                .then(response => response.json())
                .then(data => {
                    this.posts = data.posts;
                    this.loggedIn = data.logged_in > 0 ? true : false;
                    this.emitter.emit('carnetContent', this.posts);
                });
        },
        addPost(data) {
            //console.log('addPost', this.url)
            fetch(WPURLS.ajax_url+'?action=add_favorite',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': WPURLS.nonce,
                    },
                    body: JSON.stringify(data)
                })
                .then(response => response.json())
                .then(data => {
                    this.posts = data.posts;
                    this.loggedIn = data.logged_in > 0 ? true : false;
                    this.emitter.emit('carnetContent', this.posts);
                });
        },
        deletePost(data) {
            fetch(WPURLS.ajax_url+'?action=remove_favorite',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': WPURLS.nonce,
                    },
                    body: JSON.stringify(data)
                })
                .then(response => response.json())
                .then(data => {
                    this.posts = data.posts;
                    this.loggedIn = data.logged_in > 0 ? true : false;
                    this.emitter.emit('carnetContent', this.posts);
                });
        },
        logout() {
            fetch(WPURLS.ajax_url+'?action=carnet_ajaxlogout',
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'X-WP-Nonce': WPURLS.nonce
                    }
                })
                .then(response => response.json())
                .then(data => {
                    this.posts = [];
                    this.loggedIn = false;
                    this.getPosts();
                })
                .catch(error => {
                    this.posts = [];
                    this.loggedIn = false;
                    this.getPosts();
                });
        }
    }
}
</script>